import React from 'react';
import Gallery from '@browniebroke/gatsby-image-gallery'

// Override some of Lightbox options to localise labels in English
const lightboxOptions = {
    imageLoadErrorMessage: 'Unable to load image',
    nextLabel: 'Next image',
    prevLabel: 'Previous image',
    zoomInLabel: 'Zoom in',
    zoomOutLabel: 'Zoom out',
    closeLabel: 'Close',
};

function FluorescenceGallery({imagesData}) {
    const images = imagesData.map(({ node }) => node.childImageSharp);

    return (
        <div className="rn-portfolio-area mine-gallery-portfolio bg_color--1 pb--120 mx-lg-4">

            <div className="container">
                <div className="row align-items-end mb--30">
                    <div className="col-lg-12">
                        <div className="section-title text-left">
                            <h2 className="title">Gallery</h2>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="mine-row-gallery-container">
                        <div className="row">
                            <div className="mine-row-gallery-container">
                                <Gallery
                                    thumbAlt="Image from UV experience gallery at Sitarjevec Mine"
                                    images={images}
                                    lightboxOptions={lightboxOptions}
                                    gutter="0.6rem"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FluorescenceGallery;
